import {FaqQuestionGenqlSelection} from "@/gql/gen";

export const FaqQuestionFields: FaqQuestionGenqlSelection = {
    ID: true,
    NAME: true,
    DETAIL_TEXT: true,
}
